import { gql, TypedDocumentNode } from "@apollo/client";

import {
  InviteUsersToTeamMutation,
  InviteUsersToTeamMutationVariables,
} from "./InviteUsersToTeam.generated";

export const INVITE_USERS_TO_TEAM: TypedDocumentNode<
  InviteUsersToTeamMutation,
  InviteUsersToTeamMutationVariables
> = gql`
  mutation InviteUsersToTeam(
    $inviteUsersToTeamInput: InviteUsersToTeamInput!
  ) {
    inviteUsersToTeam(
      inviteUsersToTeamInput: $inviteUsersToTeamInput
    ) {
      provisionedUsers {
        existing {
          inviteUuid
          success
          email
          reason
        }
        newUsers {
          inviteUuid
          success
          email
          reason
        }
      }
    }
  }
`;
